import { TRecentItemType, useRecentContext } from 'shared/Providers/Recent';
import { useState } from 'react';
import { NavLinkListItem, NavListItem } from 'shared/_components/app-layout/nav/nav-link-list-item';
import { IconFolder, IconMic, IconRecent, IconSeries, IconVideos } from 'shared/_ui/icon';
import { Collapse, List } from '@mui/material';

const getRecentIcon = (type: TRecentItemType) => {
	switch (true) {
		case type === 'project':
			return <IconFolder />;
		case type === 'video':
			return <IconVideos />;
		case type === 'audio':
			return <IconMic />;
		case type === 'series':
			return <IconSeries />;
		default:
			return undefined;
	}
};

export default function RecentMenuItem({ drawerExpanded }: { drawerExpanded: boolean }) {
	const [recentExpanded, setRecentExpanded] = useState(false);
	const { recent } = useRecentContext();

	return (
		<>
			<NavListItem
				key="recent"
				expanded={drawerExpanded}
				text="RECENT"
				icon={<IconRecent />}
				onClick={() => setRecentExpanded((s) => !s)}
				isGroupExpanded={recentExpanded}
			/>
			<Collapse in={recentExpanded} timeout="auto" unmountOnExit sx={{ pl: 4 }}>
				<List component="div" disablePadding>
					{recent.map((it) => (
						<NavLinkListItem
							isNavLink={false}
							key={it.to}
							expanded={drawerExpanded}
							icon={getRecentIcon(it.type)}
							text={it.title}
							to={it.to}
						/>
					))}
				</List>
			</Collapse>
		</>
	);
}
